const ITEMS = [
  { text: "CUSTOMIZED SQ.FT WAREHOUSING", hot: true },
  { text: "GRADE-A FACILITY LEASING", hot: false },
  { text: "PAN-INDIA LOGISTICS NODES", hot: true },
  { text: "TWO-BID SYSTEM: TECHNICAL + FINANCIAL", hot: false },
  { text: "STORAGE & RACKING EPC", hot: true },
  { text: "ROLLING ENQUIRIES OPEN", hot: false },
];

const Strip = () => (
  <div className="flex items-center gap-12">
    {ITEMS.map((item, i) => (
      <span key={i} className={item.hot ? "text-brand" : ""}>
        {item.hot ? `■ ${item.text}` : item.text}
      </span>
    ))}
  </div>
);

const Marquee = () => (
  <section className="bg-surface text-mute py-4 border-b border-line overflow-hidden" data-testid="notice-marquee" aria-hidden="true">
    <div className="mq-track font-mono text-xs uppercase tracking-[0.2em] flex items-center gap-12 whitespace-nowrap">
      <Strip />
      <Strip />
    </div>
  </section>
);

export default Marquee;
